import axiosInstance from "./baseUrl";

export const fetchAllNotificationsService = (params: any) =>
  axiosInstance.get("/v1/notifications", { params });

export const sendSingleNotificationService = (data: any) =>
  axiosInstance.post("/v1/notifications/send-push", data);

export const sendBulkNotificationService = (data: any) =>
  axiosInstance.post("/v1/notifications/send-bulk-push", data);
